import _clonedeep from 'lodash.clonedeep'
import _debounce from 'lodash.debounce'

export default {
  props: {
    /**
     * @description 表头数据
     */
    columns: {
      type: Array,
      required: true
    },
    /**
     * @description 表格加载
     */
    loading: {
      type: Boolean,
      default: false
    },
    /**
     * @description 是否需要预设的表头背景色（可自己更改样式覆盖）
     */
    headerBgc: {
      type: Boolean,
      default: false
    },
    /**
     * @description 表格加载配置
     */
    loadingOptions: {
      type: Object,
      default: null
    },
    /**
     * @description 表格配置
     */
    options: {
      type: Object,
      default: null
    },
    /**
     * @description 索引
     */
    indexRow: {
      default: null
    },
    /**
     * @description 单选
     */
    radioRow: {
      default: null
    },
    /**
     * @description 多选
     */
    selectionRow: {
      default: null
    },
    /**
     * @description 自适应内容区高度
     */
    adaptive: {
      default: null
    },
    /**
     * @description 顶部工具栏
     */
    toolbar: {
      type: [Boolean, Object],
      default: false
    },
    /**
     * @description 顶部操作栏配置项
     */
    headerOperations: {
      default: () => []
    }
  },
  data() {
    return {
      columnsFilter: [],
      isCtrl: false,
      isShift: false,
      isWin: true,
      isMac: false,
      selectionRows: [],
      tempRadioId: false,
      checkedRow: {},
      colorRows: []
    }
  },
  created() {
    this.initColumns()
  },
  mounted() {
    if (this.selectionRow && this.selectionRow.hidden) {
      this.initKeyboard()
    }
    if (this.adaptive) {
      this.setAdaptive()
      window.addEventListener('resize', this.debounceSetAdaptive)
    }
  },
  watch: {
    columns: {
      handler() {
        this.initColumns()
      },
      deep: true
    }
  },
  beforeDestroy() {
    if (this.selectionRow && this.selectionRow.hidden) {
      document.removeEventListener('keydown', this.keyDown)
      document.removeEventListener('keyup', this.keyup)
    }
    if (this.adaptive) {
      window.removeEventListener('resize', this.debounceSetAdaptive)
    }
  },
  computed: {
    bottomSelectionRow() {
      if (this.selectionRow.hidden && this.selectionRows.length > 0) {
        return this.selectionRows.reduce((start, end) => {
          return start.$rowIndex > end.$rowIndex ? start : end
        })
      } else {
        return null
      }
    },
    topSelectionRow() {
      if (this.selectionRow.hidden && this.selectionRows.length > 0) {
        return this.selectionRows.reduce((start, end) => {
          return start.$rowIndex < end.$rowIndex ? start : end
        })
      } else {
        return null
      }
    }
  },
  methods: {
    // 初始化多选 ctrl+左键的操作
    initKeyboard() {
      this.isWin = (navigator.platform === 'Win32') || (navigator.platform === 'Windows')
      this.isMac = (navigator.platform === 'Mac68K') || (navigator.platform === 'MacPPC') || (navigator.platform === 'Macintosh') || (navigator.platform === 'MacIntel')
      document.addEventListener('keydown', this.keydown, false)
      document.addEventListener('keyup', this.keyup, false)
    },
    keydown(e) {
      // 解决按ctrl+f搜索时isCtrl为true的问题
      if (e.ctrlKey && e.keyCode === 70) {
        this.isCtrl = false
        return
      }
      if ((e.keyCode === 17 && this.isWin) || (e.keyCode === 91 && this.isMac)) {
        this.isCtrl = true
        return
      }
      if (e.keyCode === 16) {
        this.isShift = true
        document.onselectstart = () => false
      }
    },
    keyup(e) {
      if ((e.keyCode === 17 && this.isWin) || (e.keyCode === 91 && this.isMac)) {
        this.isCtrl = false
        return
      }
      if (e.keyCode === 16) {
        this.isShift = false
        document.onselectstart = () => true
      }
    },
    initColumns() {
      if (this.columnsFilter !== this.columns) {
        this.columnsFilter = _clonedeep(this.columns)
        this.columnsFilter = this.columnsFilter.filter(item => item.show !== false)
      }
      // this.columnsFilter = _clonedeep(this.columns)
      // this.columnsFilter = this.columnsFilter.filter(item => item.show !== false)
    },
    // 获取最新最上最下行
    getTopAndBottom(row, bottom, top) {
      const n = row.$rowIndex
      const mx = bottom.$rowIndex
      const mi = top.$rowIndex
      if (n > mx) {
        return {
          top: mi,
          bottom: n
        }
      } else if (n < mx && n > mi) {
        return {
          top: mi,
          bottom: n
        }
      } else if (n < mi) {
        return {
          top: n,
          bottom: mx
        }
      } else if (n === mi) {
        return {
          top: mi,
          bottom: mi
        }
      } else if (n === mx) {
        return {
          top: mi,
          bottom: mx
        }
      }
    },
    /**
     * @description 重置table搜索条件
     */
    reset() {
      this.clearFilterColumnValue()
      this.filterColumn(null, '', '')
      this.$emit('reset')
    },
    /**
     * @description 刷新table
     */
    refresh() {
      this.$emit('refresh')
    },
    /**
     * @description 导出excel
     */
    exportExcel() {
      const obj = {
        fieldList: this.columnsFilter.map(item => item.key),
        titleList: this.columnsFilter.map(item => item.title)
      }
      this.$emit('exportExcel', obj)
    },
    /**
     * @description 勾选数据时触发的事件
     */
    handleSelect(selection, row) {
      if (this.options && this.options.rowKey && this.selectionRow && this.selectionRow.isTree) {
        const selectList = this.$refs.elTable.store.states.selection
        const name = this.$refs.elTable.store.states.childrenColumnName
        const hasChildrenName = this.$refs.elTable.store.states.lazyColumnIdentifier
        if (row[hasChildrenName]) {
          const children = this.$refs.elTable.store.states.lazyTreeNodeMap[row[this.options.rowKey]]
          if (selectList.includes(row)) {
            for (const key in children) {
              if (!selectList.includes(children[key])) {
                selectList.push(children[key])
              }
            }
            this.handleSelectionChangeIsTree(selectList)
          } else {
            for (const key in children) {
              const index = selectList.indexOf(children[key])
              if (index > -1) {
                selectList.splice(index, 1)
              }
            }
            this.handleSelectionChangeIsTree(selectList)
          }
        }
        if (row[name] && row[name].length) {
          if (selectList.includes(row)) {
            this.recursive(row[name], name, true)
          } else {
            this.recursive(row[name], name, false)
          }
          this.handleSelectionChangeIsTree(selectList)
        } else {
          this.handleSelectionChangeIsTree(selectList)
        }
      }
      this.$emit('select', selection, row)
    },
    /**
     * @description 勾选全选时触发的事件
     */
    handleSelectAll(selection) {
      if (this.options && this.options.rowKey && this.selectionRow && this.selectionRow.isTree) {
        const children = this.$refs.elTable.store.states.lazyTreeNodeMap
        const selectList = this.$refs.elTable.store.states.selection
        const isAllSelected = this.$refs.elTable.store.states.isAllSelected
        const name = this.$refs.elTable.store.states.childrenColumnName
        if (isAllSelected) {
          for (const key in children) {
            const rows = children[key]
            rows.forEach((item, index) => {
              if (!selectList.includes(item)) {
                selectList.push(item)
              }
            })
          }
          this.recursive(this.apexTableData, name)
          this.handleSelectionChangeIsTree(selectList)
        } else {
          this.$refs.elTable.store.states.selection = []
          this.handleSelectionChangeIsTree([])
        }
      }
      this.$emit('select-all', selection)
    },
    // 递归勾选
    recursive(list, name, checked = true) {
      list.forEach(item1 => {
        if (this.selectionRow.selectable) {
          if (this.selectionRow.selectable(item1)) {
            this.$refs.elTable.toggleRowSelection(item1, checked)
          }
        } else {
          this.$refs.elTable.toggleRowSelection(item1, checked)
        }
        if (item1[name] && item1[name].length) {
          this.recursive(item1[name], name, checked)
        }
      })
    },
    /**
     * @description 行选中状态(单选)
     */
    handleCurrentChange(currentRow, oldCurrentRow) {
      this.checkedRow = currentRow
      this.$emit('current-change', currentRow, oldCurrentRow)
    },
    /**
     * @description 复选框选择项发生变化时触发的事件
     */
    handleSelectionChange(selection) {
      if (this.selectionRow) {
        if (this.selectionRow.isTree) {
          const selectedList = this.$refs.elTable.store.states.selection
          if (selectedList.length === 0) {
            this.handleSelectionChangeIsTree(selectedList)
          }
        } else {
          this.selectionRows = selection
          this.$emit('selection-change', selection)
        }
      }
    },
    handleSelectionChangeIsTree(selection) {
      this.selectionRows = selection
      this.$emit('selection-change', selection)
    },
    /**
     * @description 单元格 hover 进入时触发的事件
     */
    handleCellMouseEnter(row, column, cell, event) {
      this.$emit('cell-mouse-enter', row, column, cell, event)
    },
    /**
     * @description 单元格 hover 退出时触发的事件
     */
    handleCellMouseLeave(row, column, cell, event) {
      this.$emit('cell-mouse-leave', row, column, cell, event)
    },
    /**
     * @description 单元格点击时触发的事件
     */
    handleCellClick(row, column, cell, event) {
      this.$emit('cell-click', row, column, cell, event)
    },
    /**
     * @description 单元格双击时触发的事件
     */
    handleCellDblclick(row, column, cell, event) {
      this.$emit('cell-dblclick', row, column, cell, event)
    },
    // 可选中的行（排除不可选取的）
    canBeSelect(row) {
      if (this.selectionRow.selectable) {
        if (this.selectionRow.selectable(...arguments)) {
          this.$refs.elTable.toggleRowSelection(row)
          this.handleSelect(this.selectionRows, row)
        }
      } else {
        this.$refs.elTable.toggleRowSelection(row)
        this.handleSelect(this.selectionRows, row)
      }
    },
    /**
     * @description 行点击时触发的事件
     */
    handleRowClick(row, column, event) {
      if (this.radioRow || this.radioRow === '') {
        this.tempRadioId = row.$rowIndex
      }
      if (this.selectionRow && this.selectionRow.isRowClick && !this.selectionRow.hidden) {
        this.canBeSelect(row)
      }
      if (this.selectionRow && this.selectionRow.hidden && event.button === 0) {
        if (this.isCtrl && !this.isShift) { // Ctrl模式
          this.canBeSelect(row)
        }
        if (this.isShift) { // Shift模式
          if (this.selectionRows.length > 0) {
            const topAndBottom = this.getTopAndBottom(row, this.bottomSelectionRow, this.topSelectionRow)
            // 如果只有一行且点击的也是这一行则取消选择
            if (this.selectionRows.length === 1 && topAndBottom.top === topAndBottom.bottom) {
              this.$refs.elTable.toggleRowSelection(row)
            } else {
              if (this.selectionRow && this.selectionRow.shiftCustomMethod) {
                this.selectionRow.shiftCustomMethod(topAndBottom, row, column, event)
              } else {
                this.$refs.elTable.clearSelection() // 先清空 不然会导致在这两行中间之外的行状态不变
                for (let i = topAndBottom.top; i <= topAndBottom.bottom; i++) { // 选中两行之间的所有行
                  this.canBeSelect(this.apexTableData[i])
                }
              }
            }
          } else {
            this.canBeSelect(row)
          }
        }
      }
      this.$emit('row-click', row, column, event)
    },
    // mark row 行颜色改变
    colorChange(color, rows) {
      this.colorRows = rows || []
      if (color !== 'created') {
        this.$nextTick(() => {
          this.$refs.elTable.clearSelection()
        })
      }
    },
    // 标记行方法
    mrakRowFn(row) {
      const key = this.toolbar.mark
      if (key) {
        for (let i = 0; i < this.colorRows.length; i++) {
          const item = this.colorRows[i]
          if (item.key === row[key]) {
            return { background: item.color || '#fff' }
          }
        }
      }
    },
    tableRowStyle({ row, rowIndex }) {
      Object.defineProperty(row, '$rowIndex', { // 给每一行添加不可枚举属性rowIndex来标识当前行
        value: rowIndex,
        writable: true,
        enumerable: false
      })
      if (this.toolbar && this.toolbar.mark) {
        const obj = this.mrakRowFn(row)
        if (obj === undefined || (obj && (obj.background === '' || obj.background === '#fff'))) {
          if (this.options && this.options.rowStyle) {
            return this.options.rowStyle(...arguments)
          }
        } else {
          return obj
        }
      }
      if (this.options && this.options.rowStyle) {
        return this.options.rowStyle(...arguments)
      }
    },
    tableRowClassName({ row, rowIndex }) {
      if (this.options && this.options.rowKey && this.options.lazy && this.checkedRow) {
        if (this.checkedRow[this.options.rowKey] === row[this.options.rowKey]) {
          this.$nextTick(() => {
            this.tempRadioId = row.$rowIndex
          })
        }
      }
      if (!this.checkedRow) {
        this.$nextTick(() => {
          this.tempRadioId = false
        })
      }
      if ((this.selectionRow && this.selectionRow.isBgc) || (this.selectionRow && this.selectionRow.hidden)) {
        let rowName = ''
        const findRow = this.selectionRows.find(item => item.$rowIndex === row.$rowIndex)
        if (findRow) {
          rowName = 'checked-row-wh'
        }
        if (rowName === '') {
          if (this.options && this.options.rowClassName) {
            return this.options.rowClassName(...arguments)
          }
        }
        return rowName
      }
      if (this.options && this.options.rowClassName) {
        return this.options.rowClassName(...arguments)
      }
    },
    /**
     * @description 行右键点击时触发的事件
     */
    handleRowContextmenu(row, column, event) {
      this.$emit('row-contextmenu', row, column, event)
    },
    /**
     * @description 行双击时触发的事件
     */
    handleRowDblclick(row, column, event) {
      this.$emit('row-dblclick', row, column, event)
    },
    handleFilterChange(filters) {
      this.$emit('filter-change', filters)
    },
    handleHeaderDragend(newWidth, oldWidth, column, event) {
      if (this.toolbar) {
        this.$refs.apexToolbar.doResizable(newWidth, oldWidth, column)
      }
      this.$emit('header-dragend', newWidth, oldWidth, column, event)
    },
    /**
     * @description 表头点击时触发的事件
     */
    handleHeaderClick(column, event) {
      this.$emit('header-click', column, event)
    },
    /**
     * @description 表头右键点击时触发的事件
     */
    handleHeaderContextmenu(column, event) {
      this.$emit('header-contextmenu', column, event)
    },
    /**
     * @description 当用户对某一行展开或者关闭的时候会触发该事件（展开行时，回调的第二个参数为 expandedRows；树形表格时第二参数为 expanded）
     */
    handleExpandChange(row, expand) {
      this.$emit('expand-change', row, expand)
    },
    /**
     * @description 控制按钮 show 的方法
     */
    toolbarButtonShow(show = true, index, row) {
      if (typeof show === 'boolean') {
        return show
      } else if (typeof show === 'function') {
        return show(index, row)
      }
      return Boolean(show)
    },
    /**
     * @description 控制按钮 disabled 的方法
     */
    toolbarButtonDisabled(disabled = false, index, row) {
      if (typeof disabled === 'boolean') {
        return disabled
      } else if (typeof disabled === 'function') {
        return disabled(index, row)
      }
      return Boolean(disabled)
    },
    /**
     * columns filter 用户配置修改
     * @param columns
     */
    handleColumnsFilterChanged(columns) {
      this.columnsFilter = columns.filter(item => item.show !== false)
      this.$nextTick(() => {
        this.$refs.elTable.doLayout()
        this.$emit('columnsFilterChange', this.columnsFilter)
      })
    },
    /**
     * 组合排序变化触发
     * @param columns
     */
    handleCombSortChange(sortList, changeType) {
      this.$emit('comb-sort-change', sortList, changeType)
    },
    /**
     * toolbar自定义按钮事件
     * @param emitName
     */
    handleToolbarEmit(emitName) {
      emitName && this.$emit(emitName)
    },
    /**
     * 让表哥index序号连续
     * @param index
     */
    continuousIndexMethod(index) {
      if (this.indexRow && this.indexRow.continuous) {
        const curpage = this.apexTablePagination.currentPage // 单前页码，具体看组件取值
        const limitpage = this.apexTablePagination.pageSize // 每页条数，具体是组件取值
        return index + 1 + (curpage - 1) * limitpage
      } else {
        return index + 1
      }
    },
    // 设置表格内容高度
    setAdaptive() {
      this.$nextTick(() => {
        const tableWrapper = this.$refs.elTable.$el
        const offsetBottom = this.adaptive.offsetBottom || 60
        tableWrapper.style.height = `${
          window.innerHeight -
          tableWrapper.getBoundingClientRect().top -
          offsetBottom
        }px`
      })
    },
    // 窗口变化后表格高度响应式变化（防抖）
    debounceSetAdaptive() {
      const debouncedSetAdaptive = _debounce(
        this.setAdaptive,
        this.adaptive.timeout || 60
      )
      debouncedSetAdaptive()
    }
  }
}
